import { useEffect, useState } from 'react';
import { isSignedIn, readSignoutReason, subscribeAuth, type SignoutReason } from './client.js';

/**
 * The two subscriptions every shell needs — the consumer App and the control
 * room at /admin both render "signed in?" and "why was I signed out?" from the
 * client's auth state, so they live here rather than inside one of the shells.
 */
export function useSignedIn(): boolean {
  const [signedIn, setSignedIn] = useState(isSignedIn);
  useEffect(() => subscribeAuth(() => setSignedIn(isSignedIn())), []);
  return signedIn;
}

export function useSignoutReason(): SignoutReason | null {
  const [reason, setReason] = useState(readSignoutReason);
  useEffect(() => subscribeAuth(() => setReason(readSignoutReason())), []);
  return reason;
}
